import { ValidationMethod } from '@/helpers/validation/Validator';
import i18n from '@/localization/localization';

const int: ValidationMethod = (input, key = '') => {
    const check = typeof input === 'number' && Number.isInteger(input);

    return {
        success: check,
        message: !check ? i18n.t('validation.validation_int', { key }).toString() : undefined,
    };
};

export default int;
